export const Slider1 = [
  { source: '/images/mockups/mobile-ecoleta-1.svg' },
  { source: '/images/mockups/mobile-ecoleta-2.svg' },
  {
    source: '/images/mockups/mobile-ecoleta-3.svg',
    avif: '/images/mockups/mobile-ecoleta-3.avif',
    webp: '/images/mockups/mobile-ecoleta-3.webp'
  },
  {
    source: '/images/mockups/mobile-ecoleta-4.svg',
    avif: '/images/mockups/mobile-ecoleta-4.avif',
    webp: '/images/mockups/mobile-ecoleta-4.webp'
  }
]

export const Slider2 = [
  { source: '/images/mockups/plantManager-1.svg' },
  { source: '/images/mockups/plantManager-2.svg' },
  { source: '/images/mockups/plantManager-3.svg' },
  { source: '/images/mockups/plantManager-4.svg' },
  { source: '/images/mockups/plantManager-5.svg' },
  { source: '/images/mockups/plantManager-6.svg' },
  { source: '/images/mockups/plantManager-8.svg' },
  { source: '/images/mockups/plantManager-9.svg' },
  {
    source: '/images/mockups/plantManager-10.svg',
    avif: '/images/mockups/plantManager-10.avif',
    webp: '/images/mockups/plantManager-10.webp'
  }
]

export const Slider3 = [
  { source: '/images/mockups/plantManager-dark-1.svg' },
  { source: '/images/mockups/plantManager-dark-2.svg' },
  { source: '/images/mockups/plantManager-dark-3.svg' },
  { source: '/images/mockups/plantManager-dark-4.svg' },
  { source: '/images/mockups/plantManager-dark-5.svg' },
  { source: '/images/mockups/plantManager-dark-6.svg' },
  { source: '/images/mockups/plantManager-dark-8.svg' },
  { source: '/images/mockups/plantManager-dark-9.svg' },
  { source: '/images/mockups/plantManager-dark-10.svg' }
]
